import React from 'react';
import { StyleSheet } from 'react-native';
import { DisplayText, theme } from '@sweetgreen/garnish';

import { useCustomerNameQuery } from '../../GraphQL/AccountMenu.generated';

export const AccountCustomerName = () => {
  const [response] = useCustomerNameQuery();
  const customerName = response.data?.currentCustomer?.firstName;

  return (
    <DisplayText
      testID="account.menu-customer-name"
      style={styles.title}
      size={3}
    >
      {customerName}
    </DisplayText>
  );
};

const styles = StyleSheet.create({
  title: {
    paddingVertical: theme.spacing.large,
  },
});
